import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetSection } from "../../store/api/sectionApi";

function SectionList({ onEdit }) {
  const getSection = useGetSection();
  const {
    data: sectionData,
    isLoading: isSectionLoading,
    error: sectionError,
  } = useQuery({ queryKey: "section", queryFn: getSection });

  const data = sectionData?.allSection
    ?.map((section, index) => ({
      index: index + 1,
      secId: section?.idNumber,
      categoryName: section?.category?.name,
      actionButton: (
        <>
          <button
            onClick={() => onEdit(section)}
            className="btn text-success mx-2"
          >
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Section ID",
      accessor: "secId",
    },
    {
      header: "Category Name",
      accessor: "categoryName",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isSectionLoading} />
    </div>
  );
}

export default SectionList;
